<template>
  <div class="product-list" :class="'terminal' + terminal">
    <div class="picListWarp" v-if="componentContent.arrangeType == '横向滑动'">
      <div class="picList" v-if="productData && productData.length > 0">
        <div class="pro-button-prev"></div>
        <div class="pro-button-next"></div>
        <swiper ref="swiper" class="products-swiper" :options="swiperOption">
          <swiper-slide class="products-swiper-slide item" v-for="(item, index) in productData" :key="index">
            <productBox :item="item" :isShowShop="isShowShop" />
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div v-else class="picList">
      <div class="category-tags">
        <div class="tag-item">
          <div class="tag-icon">
            <img style="width: 24px;height: 24px;" src="@/assets/images/Icon/Popular.png" alt="" />
          </div>
          <div class="tag-text">热门商品</div>
        </div>
        <div class="tag-item" v-for="(tag, index) in tags" :key="index" @click="handleTagClick(tag)">
          <div class="tag-icon">
            <img style="width: 24px;height: 24px;" :src="tag.classifyImage" alt="" />
          </div>
          <div class="tag-text">{{ tag.classifyName }}</div>
        </div>
      </div>
      <ul class="clearfix" :class="'imgTextNum' + componentContent.productNum">
        <li class="item"
          v-for="(item, index) in productData.slice(0, componentContent.productRowNum * componentContent.productNum)"
          :key="index">
          <productBox :isShowShop="isShowShop" :item="item" />
        </li>
      </ul>
    </div>
    <button v-show="componentContent.showMore" class="btn-more" @click="jumpProList(componentContent.productData)">查看全部
      <span class="icon iconfont icon-arrow-right"></span></button>
  </div>
</template>

<script>
import { commonMixin } from '../mixin'
import productBox from '@/components/base/productBox'
import { mapMutations } from 'vuex'

import { getCategory } from '@/api/nav.js'

export default {
  mixins: [commonMixin],
  components: {
    productBox
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 4, // 显示数量
        spaceBetween: 13, // 间隔
        autoplay: false, // 可选选项，自动滑动
        loop: true,
        pagination: {
          el: '.product-pagination'
        },
        navigation: {
          nextEl: '.pro-button-next',
          prevEl: '.pro-button-prev'
        }
      },
      tags: []
    }
  },
  async mounted () {
    this.getCategoryMtd()
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ',
    }),
    handleTagClick (tag) {
      this.setSearchObj({
          keyword: tag.classifyName || '',
          searchVal: '商品'
      })
      this.$router.push({
          name: 'category',
          query: {
              classifyData: JSON.stringify(tag)
          }
      })
    },
    getCategoryMtd () {
      getCategory({ classifyId: 0 }).then(res => {
        // 去除第一个元素，然后随机取五个
        if (res.data.data && res.data.data.length > 0) {
          const filteredTags = res.data.data.slice(1) // 去除第一个元素
          const randomTags = this.getRandomTags(filteredTags, 5) // 随机取五个
          this.tags = randomTags
        } else {
          this.tags = []
        }
      })
    },
    // 添加一个获取随机标签的方法
    getRandomTags (tags, count) {
      // 如果标签数量小于等于需要的数量，直接返回所有标签
      if (tags.length <= count) {
        return tags
      }

      // 随机选择指定数量的标签
      const shuffled = [...tags].sort(() => 0.5 - Math.random())
      return shuffled.slice(0, count)
    }
  }
}
</script>

<style lang="scss" scoped>
.product-list {
  padding: 16px;
  background-color: #fff;

  .picListWarp {
    width: 1380px;
    max-width: 100%;
    margin: 0 auto;
    position: relative;
  }

  .picList {

    .pro-button-prev,
    .pro-button-next {
      width: 50px;
      height: 50px;
      position: absolute;
      cursor: pointer;
      top: 140px;
      background-repeat: no-repeat;

      &:after {
        content: '';
      }
    }

    .pro-button-prev {
      left: 0;
      background: url('../../../static/images/btn-prev.png');
    }

    .pro-button-next {
      right: 0;
      background: url('../../../static/images/btn-next.png');
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      gap: 8.8px;
    }

    // .imgTextNum2 {
    //   li {
    //     flex: 0 0 50%;
    //   }
    // }

    // .imgTextNum3 {
    //   li {
    //     flex: 0 0 33.33%;
    //   }
    // }

    // .imgTextNum4 {
    //   li {
    //     flex: 0 0 25%;
    //   }
    // }

    // .imgTextNum5 {
    // }
  }

  .category-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-bottom: 16px;

    .tag-item {
      display: flex;
      align-items: center;
      padding: 6px 8px;
      border-radius: 4px;
      background-color: #F4F8FE;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        // background: linear-gradient( 90deg, #584DFF 40%, #1866ED 100%);
        transform: translateY(-2px);
      }

      .tag-icon {
        width: 24px;
        min-width: 24px;
        height: 24px;
        margin-right: 4px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .tag-text {
        font-size: 16px;
        color: #4B5B76;
        font-weight: 500;
      }
    }
  }

  // 特殊样式 - 热门商品标签
  .tag-item:nth-child(1) {

    // background: linear-gradient( 90deg, #584DFF 40%, #1866ED 100%);
    .tag-icon {
      width: 20px;
      height: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .tag-text {
      background: linear-gradient(7.064707531409216e-7deg, #584DFF 40%, #1866ED 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    }
  }
}

.btn-more {
  width: 130px;
  height: 41px;
  border: 2px solid #C5AA7B;
  color: #C5AA7B;
  font-size: 18px;
  background-color: transparent;
  margin: 20px auto 0;
  display: block;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/canvasShow/basics/product/pc/index.vue